import {updateCompanyinRedux} from '@/redux-store/slices/admin/companies';
import {store} from '@/redux-store/store';
import keycloakAxios from '@/services/axios';

export const setCompanyModules = async (
  companyId: string,
  moduleData: string[]
) => {
  const requestBody = {
    company: companyId,
    modules: moduleData
  };
  const response = await keycloakAxios.post(
    `admin/company/setmodules`,
    requestBody
  );

  if (response.status >= 300) {
    throw new Error(
      `Error setting modules: Invalid status code: ${response.status}`
    );
  }

  store.dispatch(updateCompanyinRedux({company: response.data}));

  return response.data;
};
